import loadable from '@loadable/component';

export const LoadableNavBarDesktop = loadable(
  () =>
    import(
      /* webpackChunkName: "NavBarDesktop" */ '../components/NavBarDesktop'
    ),
);
